import { useGetAccountsYearsQuery } from "../../../../services";
import { YearOption } from "../types";
import { UseYearNavigationReturn } from "./types";

const currentYearOption = (): YearOption => {
  const currentYear = new Date().getFullYear();
  return { label: currentYear.toString(), value: currentYear };
};

// Falls back to the current year so the filter always has something to select;
// hasActivityHistory stays independent, reporting what the API actually returned.
export const useYearNavigation = (): UseYearNavigationReturn => {
  const { data } = useGetAccountsYearsQuery();
  const result = data ?? [];

  const yearOptions: YearOption[] = result.map((year) => ({
    label: year.toString(),
    value: year,
  }));

  const years = yearOptions.length > 0 ? yearOptions : [currentYearOption()];

  return { years, hasActivityHistory: result.length > 0 };
};
